import { SVGProps } from 'react';

const DownChevronIcon = ({
  height = '64px',
  width = '64px',
  strokeWidth = '2',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 64 64'
    className='stroke-current'
    {...props}
  >
    <path
      data-name='layer1'
      fill='none'
      strokeMiterlimit='10'
      strokeWidth={strokeWidth}
      d='M20 26l11.994 14L44 26'
      strokeLinejoin='round'
      strokeLinecap='round'
    ></path>
  </svg>
);

export default DownChevronIcon;
